import { gql } from '@apollo/client';
import { useQuery } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { defaultTo, isUndefined } from 'lodash-es';
import { compareAufgabe } from '../../core/application/objekt-aufgaben-comparator';
import type { ObjektQuery } from './__generated__/objekt';

type Objekt_objekt = Exclude<ObjektQuery['objekt'], null>;

export const useObjekt = (objektId: string) => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();

  const { loading, data } = useQuery<ObjektQuery>(gql`
    query Objekt($id: UUID!) {
      objekt(id: $id) {
        name
        name2
        nummer
        channel
        betriebstyp
        hatSaal
        hatTerrasse
        hatBiergarten
        adresse {
          strasse
          postleitzahl
          ort
        }
        aufgaben {
          id
          titel
          typ
          status
          ergebnis
          faelligkeit
          objekt {
            id
          }
        }
        additionalInformation {
          key
          value
        }
      }
    }
  `, {
    variables: { id: objektId },
    fetchPolicy: 'cache-and-network',
    onError: handleWithErrorNotification('Objekt konnte nicht geladen werden.'),
  });

  return {
    loading,
    objekt: defaultTo(sortAufgaben(data?.objekt), null),
  };
};

const sortAufgaben = (objekt: Objekt_objekt | undefined): Objekt_objekt | undefined => {
  if (isUndefined(objekt)) {
    return objekt;
  }

  return {
    ...objekt,
    aufgaben: (objekt?.aufgaben ?? [])
      .filter(aufgabe => aufgabe.status === 'Offen' || aufgabe.status === 'Abgeschlossen')
      .sort(compareAufgabe),
  };
};
